var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5345 2.00453C12.0738 -0.663618 15.9247 -0.663619 17.464 2.00453L27.2697 19.0012C28.8082 21.6679 26.8836 25.0001 23.805 25.0001H4.19346C1.11483 25.0001 -0.80974 21.6679 0.728721 19.0012L10.5345 2.00453ZM13.9995 9C14.5518 9 14.9995 9.44771 14.9995 10V15C14.9995 15.5523 14.5518 16 13.9995 16C13.4472 16 12.9995 15.5523 12.9995 15V10C12.9995 9.44771 13.4472 9 13.9995 9ZM13.9995 20C14.5518 20 14.9995 19.5523 14.9995 19C14.9995 18.4477 14.5518 18 13.9995 18C13.4472 18 12.9995 18.4477 12.9995 19C12.9995 19.5523 13.4472 20 13.9995 20Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.b5ea747372669421576a565447275869.svg";
export { ForwardRef as ReactComponent };